import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'app/App';
import { init } from 'app/services/auth';
import packageJson from '../package.json';

import './index.css';

console.info(`Pharos Control Dashboard v${packageJson.version}`);

document.title = 'Cyberseconomics';

const main = async (): Promise<void> => {
  try {
    await init();
  } catch (err) {
    // do nothing
    void err;
  }
  const appContainer = document.querySelector('#app');
  if (!appContainer) {
    throw new Error('Unable to mount app: #app container not found');
  }

  createRoot(appContainer).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

main();
